export const itemLists_api = {
  url: 'itemLists',
  method: 'post',
  title: '商品列表',
}

export const export_api = {
  url: 'itemListsDownload',
  method: 'post',
  title: '商品列表导出',
}


// WEBPACK FOOTER //
// ./src/views/base/item/desc.js